import { produce } from 'immer';

import { getSettingsDictionary, updateSettingsDictionary } from '../actions/settings';

const initialState = {
  dictionary: [],
  scheduledEmails: [],
  loading: false,
  error: null,
  loadings: { updateDictionary: false },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET SETTINGS DICTIONARY
    case getSettingsDictionary.types.START:
      state.loading = true;
      state.error = null;
      return state;

    case getSettingsDictionary.types.SUCCESS:
      state.loading = false;
      state.dictionary = action.payload.settings;
      state.scheduledEmails = action.payload.report_schedules || [];
      return state;

    case getSettingsDictionary.types.FAIL:
      state.loading = false;
      state.error = action.payload;
      return state;

    // UPDATE SETTINGS DICTIONARY
    case updateSettingsDictionary.types.START:
      state.loadings.updateDictionary = true;
      return state;

    case updateSettingsDictionary.types.SUCCESS:
      state.loadings.updateDictionary = false;
      state.dictionary = action.payload.settings;
      return state;

    case updateSettingsDictionary.types.FAIL:
      state.loadings.updateDictionary = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
